import React from "react";
import PropTypes from "prop-types";
import { accessorPropsType, clusterKeys, getColor } from "./utils";
import { rgb } from "d3-color";



/** Memoized component to render all our circles, re-render only if its props change**/
const Circles = React.memo(({ data, xScale, xAccessor, yScale, yAccessor, defaultColor = "steelBlue", graphType }) => {

    return (
        <React.Fragment key={crypto.randomUUID()}>
            <g data-testid="Points">
                {data.map((d, i) => {
                    const x = xScale(xAccessor(d));
                    const y = yScale(yAccessor(d));
                    // const r = rScale?.(rAccessor(d)) ?? radius;
                    const color = getColor(d, data, graphType);
                    return (
                        x && y ?
                            <circle
                                key={crypto.randomUUID()}
                                r="3"
                                cx={x}
                                cy={y}
                                fill={color}
                                stroke="white"
                                strokeWidth={1}
                                strokeOpacity={1}
                                fillOpacity={0.5}
                            /> : <div>"Co-ordinates are still being computed.. pls wait"
                            </div>
                    )
                })}
            </g>
        </React.Fragment>

    );
}
)

Circles.propTypes = {
    data: PropTypes.array,
    xAccessor: accessorPropsType,
    yAccessor: accessorPropsType,
    radius: accessorPropsType,
}

Circles.defaultProps = {
    radius: 5,
}

export default Circles
